module.exports = __webpack_public_path__ + "static/media/success-check-red.601d5346.png";